import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import {
  Grid,
  Chip as MuiChip,
  Typography,
} from "@mui/material";
import { toast } from "react-toastify";

import {
  renderColumnDataGrid,
  getSubFormContrlsObj,
  parseAndRound,
} from "src/utils/amUtils";
import AMFooterTable from "src/pages/components/AMFooterTableByDataGrid";
import FormInput from "src/pages/components/AMFormInput";
import * as Enums from "src/utils/enums";
import useForm from "src/hooks/useForm";
import { getCaption } from "src/utils/dictionary";

const Chip = styled(MuiChip)(spacing);

function InvTrxExpenses({ formControls, tableData, title, setTableData }) {
  const [columns, setColumns] = useState([]);
  const [summary, setSummary] = useState({
    rowsCount: 0,
    sumAmount: 0,
  });

  //initColumns;
  useEffect(() => {
    const initColumns = () => {
      const columns = [];
      columns.push(renderColumnDataGrid("id", {}, { hide: true }));
      columns.push(renderColumnDataGrid("expenseTypeID", {}, { hide: true }));
      columns.push(renderColumnDataGrid("serial", formControls.serial));
      columns.push(renderColumnDataGrid("expenseTypeName", formControls.expenseTypeName));
      columns.push(renderColumnDataGrid("amount", formControls.amount));
      columns.push(renderColumnDataGrid("notes", formControls.notes));

      return columns;
    };

    setColumns(initColumns());
  }, [formControls]);

  useEffect(() => {
    const newSummary = {
      rowsCount: 0,
      sumAmount: 0,
    };

    if (tableData && tableData.length) {
      newSummary.rowsCount = tableData.length;
      newSummary.sumAmount = parseAndRound(
        tableData.reduce((sum, o) => {
          return sum + parseAndRound(o.amount);
        }, 0),
        4
      );
    }
    setSummary((state) => ({ ...state, ...newSummary }));
  }, [tableData]);

  const handleExpenseTypeSelectedIndexChanged = (event, value, reason, fieldName) => {
    try {
      let colName = "";
      switch (fieldName) {
        case "expenseTypeID":
          colName = "expenseTypeName";
          break;
        default:
          break;
      }
      if (colName && value)
        setSubFormState({
          [colName]: value.textField,
        });
      handleSelectedIndexChange(event, value, reason, fieldName);
    } catch (error) {
      throw error;
    }
  };

  const handleExpenseTypeChanged = (event, value, reason, fieldName) => {
    try {
      handleExpenseTypeSelectedIndexChanged(event, value, reason, fieldName);
    } catch (error) {
      throw error;
    }
  };

  //#region Add/Edit Form

  const {
    state: subFormState,
    errors: subFormErrors,
    handleSetState: setSubFormState,
    handleSetFullState: setSubFormFullState,
    handleSelectedIndexChange: handleSelectedIndexChange,
    renderFormInput,
    vaLidateFormData: defaultValidateSubFormData,
  } = useForm({
    menuItemCode: "",
    nextCodeField: "",
    getNextCodeFunc: null,
    getByIdFunc: null,
    saveFunction: null,
    deleteFunction: null,
    isSubForm: true,
    subFormControls: getSubFormContrlsObj(formControls, [
      "expenseTypeID",
      "serial",
      "expenseTypeName",
      "amount",
      "notes",
    ]),
  });

  const editForm = (
    <Grid container spacing={4}>
      {renderFormInput(
        "serial",
        Enums.ControlType.TextField,
        {
          disabled: true,
          style: { maxWidth: 100 },
        },
        { sm: 2 }
      )}
      <FormInput
        type={Enums.ControlType.AutoSearch}
        name={"expenseTypeID"}
        control={formControls["expenseTypeID"]}
        onChange={handleExpenseTypeChanged}
        value={subFormState["expenseTypeID"] || ""}
        errorMsg={subFormErrors["expenseTypeID"]}
        gridItemProps={{ sm: 3 }}
      />
      {renderFormInput(
        "amount",
        Enums.ControlType.TextField,
        {},
        { sm: 2 }
      )}
      {renderFormInput(
        "notes",
        Enums.ControlType.TextField,
        {},
        { sm: 5 }
      )}
    </Grid>
  );
  //#endregion

  const validateSubFormData = () => {
    if (defaultValidateSubFormData()) {
      const amount = parseAndRound(subFormState.amount);
      if (amount <= 0) {
        toast.error(getCaption("amount_more_than_zero"));
        return false;
      }
      if (!subFormState.expenseTypeID) {
        toast.error(getCaption("expense_type_required"));
        return false;
      }
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      {columns.length > 0 && (
        <AMFooterTable
          title={title}
          columns={columns}
          tableData={tableData}
          setTableData={setTableData}
          subFormState={subFormState}
          setSubFormState={setSubFormFullState}
          subFormErrors={subFormErrors}
          validateSubFormData={validateSubFormData}
          editForm={editForm}
        />
      )}
      <Grid justifyContent="space-between" container spacing={10}>
        <Grid item></Grid>
        <Grid item alignContent="right" justifyContent="right">
          <Grid container>
            <Grid item>
              <Chip
                label={
                  <Typography variant="button" component="h2">
                    {`Total Expenses : ${parseAndRound(
                      summary.sumAmount,
                      4
                    ).toLocaleString(undefined)}`}
                  </Typography>
                }
                color="secondary"
                m={1}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
export default InvTrxExpenses;
